import React, { useEffect, useEffectEvent, useRef } from 'react'
import loadYouTubeIframeApi from '@lib/youtube-iframe-api'

// YouTube player built with the IFrame Player API. Reports play, pause and
// end to the slideshow and is destroyed on unmount.
const YouTube = ({ videoId, autoplay = false, title, onPlay, onPause, onEnded }) => {
  const containerRef = useRef(null)

  const handleStateChange = useEffectEvent((state, YT) => {
    if (state === YT.PlayerState.PLAYING) onPlay?.()
    else if (state === YT.PlayerState.PAUSED) onPause?.()
    else if (state === YT.PlayerState.ENDED) onEnded?.()
  })

  // A player error stops playback, so hand control back to the timer.
  const handleError = useEffectEvent(() => onPause?.())

  useEffect(() => {
    const container = containerRef.current
    let player = null
    let destroyed = false

    loadYouTubeIframeApi()
      .then(YT => {
        if (destroyed) return
        // The API replaces its target element, so give it one React doesn't own.
        const target = document.createElement('div')
        container.appendChild(target)
        player = new YT.Player(target, {
          videoId,
          width: '100%',
          height: '100%',
          playerVars: {
            autoplay: autoplay ? 1 : 0,
            mute: autoplay ? 1 : 0,
            playsinline: 1,
            rel: 0
          },
          events: {
            onReady: event => {
              if (!destroyed && title) event.target.getIframe().title = title
            },
            onStateChange: event => {
              if (!destroyed) handleStateChange(event.data, YT)
            },
            onError: () => {
              if (!destroyed) handleError()
            }
          }
        })
      })
      .catch(() => {})

    return () => {
      destroyed = true
      player?.destroy()
      container.replaceChildren()
    }
  }, [videoId, autoplay, title])

  return (
    <div
      ref={containerRef}
      className='absolute inset-0 [&_iframe]:w-full [&_iframe]:h-full'
    />
  )
}

export default YouTube
